/**
 * Single source of truth for resolving the backend API base URL.
 *
 * - Server-side (SSR / Node): returns `INTERNAL_API_BASE_URL` if set,
 *   falling back to `NEXT_PUBLIC_BASE_URL` or `""`.
 * - Browser (Client): returns `NEXT_PUBLIC_BASE_URL` or `""`.
 */
export function resolveApiBaseUrl(): string {
  if (typeof window === "undefined") {
    return process.env.INTERNAL_API_BASE_URL || process.env.NEXT_PUBLIC_BASE_URL || "";
  }

  return process.env.NEXT_PUBLIC_BASE_URL || "";
}

